//#region DevExtreme Imports

import 'devextreme/ui/button'
import 'devextreme/ui/check_box'
import 'devextreme/ui/select_box'
import 'devextreme/ui/switch'
import 'devextreme/ui/text_box'
import 'devextreme/ui/validator'
import 'devextreme/ui/validation_group'

//#endregion

import { USER_SESSION_SERVICE_NAME, UserSessionService } from '../../../../services/user-session'
import { AlarmDefinitionItemEditController } from './alarm-definition-item-edit.controller'

//#region Asset Imports

import './alarm-definition-item-edit.scss'
import * as TEMPLATE from './alarm-definition-item-edit.tpl.html'

//#endregion

// #region Consts

export const COMPONENT_NAME: string = 'alarmDefinitionItemEdit'

// #endregion

export class AlarmDefinitionItemEditComponent {

    controller = [
        USER_SESSION_SERVICE_NAME,
        (
            userSessionService: UserSessionService
        ) => {
            return new AlarmDefinitionItemEditController(userSessionService)
        }
    ]

    bindings = {
        options: '<',
    } as { [index: string]: string }

    template = TEMPLATE
}
